import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Estuve 7 meses con alguien que desde la cita 2 me dio señales que decidí ignorar. Me dije que era yo siendo demasiado exigente. CÓDIGO ROJO me enseñó que no era exigencia, era información. Ojalá lo hubiera tenido antes.',
  author: 'Valentina R., 31 años',
  location: 'Bogotá, Colombia',
  tag: '7 meses ahorrados',
  image: 'https://cdn.magicpatterns.com/uploads/foknZbGDHdWPMpwAfnUE2f/IMG_8390.jpg'
}, {
  quote: 'Lo apliqué en mis primeras 3 citas con alguien que parecía perfecto. En el sensor 4 todo se cayó. Cerré el proceso esa misma noche sin drama y sin culpa.',
  author: 'Mariana T., 28 años',
  location: 'Ciudad de México',
  tag: 'Detectado en cita 2',
  image: 'https://cdn.magicpatterns.com/uploads/iPi6enDAGWGqNCRAMePBvK/IMG_8389.jpg'
}, {
  quote: 'Esto no solo sirve para detectar rojos. También me ayudó a reconocer cuando alguien realmente vale la pena. Mi pareja actual pasó los 20 sensores sin esfuerzo. Eso me dio una seguridad que nunca había tenido.',
  author: 'Camila V., 29 años',
  location: 'Monterrey, México',
  tag: 'Encontró su Código Verde',
  image: 'https://cdn.magicpatterns.com/uploads/rnjNMmw4n3RKKY8BZ1QrF7/IMG_8388.jpg'
}];
function FiveStars() {
  return <div className="flex gap-0.5 mb-3" data-id="element-276">
      {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} className="fill-yellow-400 text-yellow-400" data-id="element-277" />)}
    </div>;
}
export function TestimonialsSection() {
  return <section className="px-5 py-10 max-w-[640px] mx-auto" data-id="element-278">
      <span className="inline-block bg-[var(--accent)] text-white text-[11px] font-bold tracking-widest px-3.5 py-1.5 rounded-full mb-4 uppercase" data-id="element-279">
        RESULTADOS REALES
      </span>

      <h2 className="text-[clamp(24px,6vw,36px)] font-extrabold leading-tight" data-id="element-280">
        Mujeres que dejaron de adivinar.
      </h2>

      <p className="text-[var(--muted)] text-[17px] mt-3" data-id="element-281">
        Cada historia es diferente. El sistema es el mismo.
      </p>

      <div className="mt-7" data-id="element-282">
        {testimonials.map((testimonial, index) => <div key={index} className="bg-[var(--card)] border-t-2 border-[var(--accent)]/30 rounded-xl p-6 mb-4" data-id="element-283">
            <FiveStars data-id="element-284" />
            <blockquote className="text-[15px] leading-relaxed mb-4 text-[#ddd]" data-id="element-285">
              "{testimonial.quote}"
            </blockquote>
            <div className="flex items-center gap-3" data-id="element-286">
              <img src={testimonial.image} alt={testimonial.author} className="w-11 h-11 rounded-full object-cover flex-shrink-0 border-2 border-[var(--accent)]/30" data-id="element-287" />
              <div data-id="element-288">
                <div className="font-bold text-sm" data-id="element-289">{testimonial.author}</div>
                <div className="text-[var(--muted)] text-[13px] mt-0.5" data-id="element-290">
                  {testimonial.location}
                </div>
              </div>
            </div>
            <span className="inline-block bg-[#1a1015] text-[var(--red2)] text-xs px-3 py-1 rounded-lg mt-3 font-semibold" data-id="element-291">
              {testimonial.tag}
            </span>
          </div>)}
      </div>
    </section>;
}